module.exports = __webpack_public_path__ + "img/CIUDADANO_WEB.4e7005cc.svg";